import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import React from 'react';
import styled from 'styled-components';
import { Progress, Box, Text } from '@landr/maestro';
import { useProfileProviderContext } from '../../ProfileProvider/ProfileProvider.es.js';

var _templateObject;
var ProgressStyled = styled(Progress)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    circle:last-child {\n        stroke: #1d95ff; //accent.500 in maestro v4\n    }\n"])));
var ProfileCompletion = function ProfileCompletion() {
  var _useProfileProviderCo = useProfileProviderContext(),
    data = _useProfileProviderCo.data,
    error = _useProfileProviderCo.error,
    isLoading = _useProfileProviderCo.isLoading;
  var profile = data === null || data === void 0 ? void 0 : data.currentProfile;
  if (!profile) {
    return null;
  }
  var profileCompletion = profile.profileCompletion;
  var isProfileCompletionVisible = isLoading || error || profileCompletion === undefined || profileCompletion >= 100 || profileCompletion < 0;
  if (isProfileCompletionVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "data-testid": "profile-completion-progress"
  }, /*#__PURE__*/React.createElement(ProgressStyled, {
    size: 'sm',
    progress: profileCompletion / 100
  }), /*#__PURE__*/React.createElement(Text, {
    ml: "xs",
    size: "xs"
  }, profileCompletion, "%"));
};

export { ProfileCompletion, ProgressStyled };
